var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcelandFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 40,
    fill: "#02529c"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    width: 8,
    height: 40,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 16,
    width: 60,
    height: 8,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    width: 4,
    height: 40,
    fill: "#dc1e35"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 18,
    width: 60,
    height: 4,
    fill: "#dc1e35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcelandFlag);
export default __webpack_public_path__ + "static/media/iceland-flag.fe27f19009651a65f1f00b7b2b35bdb4.svg";
export { ForwardRef as ReactComponent };